import Item from "../item";
import { ItemName } from "../item/item-types";

type CauldronCookingProps = {
    ingredients: [ItemName, ItemName];
    resultFood: ItemName;
}
const CauldronCooking: React.FC<CauldronCookingProps> = ({
    ingredients,
    resultFood
}) => (
    <div className='cauldron-cooking'>
        <Item itemName={ingredients[0]} />
        <div className='cauldron-cooking-operator'> + </div>
        <Item itemName={ingredients[1]} />
        <div className='cauldron-cooking-operator'> = </div>
        <Item itemName={resultFood} />
    </div>
);
export default CauldronCooking;